<template>
  <router-link
    class="course-lesson-link card text-decoration-none text-light mb-2"
    :to="{ name: 'lesson', params }"
  >
    <div class="card-body d-flex align-items-center">
      <span class="flex-fill pr-2">
        {{ lesson.name }}
      </span>

      <div
        v-if="lesson.progress && lesson.progress.finished_at"
        class="circle check"
      >
        <img src="https://img.icons8.com/metro/16/FFFFFF/checkmark.png" />
      </div>

      <template v-else>
        <div class="circle play-current">
          <img src="https://img.icons8.com/metro/16/EF4D57/play.png" />
        </div>
        <div class="circle play-next">
          <img src="https://img.icons8.com/metro/16/C8D6E5/play.png" />
        </div>
      </template>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    courseId: {
      type: Number,
      required: false
    },
    lesson: {
      type: Object,
      required: true
    }
  },
  computed: {
    params() {
      const pastCourseId = this.courseId ? { id: this.courseId } : {};
      return { ...pastCourseId, lesson: this.lesson.id };
    }
  }
};
</script>

<style lang="scss" scoped>
.course-lesson-link {
  border-right: none;
  border-left: none;
  background: transparent;
  text-align: left;
  font-size: 14px;
  background: #131212;
  border: none;
  font-weight: bold;

  &:hover {
    background: rgba(100, 100, 100, 0.05);
  }

  .circle {
    min-width: 24px;
    min-height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .check {
    background: #04c56b;
  }

  .play-current {
    border: 1px solid #ef4d57;
    display: none;
  }

  .play-next {
    border: 1px solid #c8d6e5;
  }

  .router-link-exact-active {
    .play-current {
      display: flex;
    }

    .play-next {
      display: none;
    }
  }
}
</style>
